import { SortingOptionsType } from '@components/design/migrated/Table';
import { useCallback } from 'react';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

interface PersistedSortingArgsPAStackedChart {
  tableId: string;
  defaultSorting: SortingOptionsType;
}

export interface PersistedSortingPAStackedChart {
  stackedChartSorting: SortingOptionsType;
  updateStackedChartSortingOptions: (options: SortingOptionsType) => void;
}

const usePersistedSortingPerformanceAnalysisStackedChart = ({
  tableId,
  defaultSorting,
}: PersistedSortingArgsPAStackedChart): PersistedSortingPAStackedChart => {
  const pagesConfig = usePageConfig();

  const getSortingOptions = () => {
    if (Object.keys(pagesConfig.sortingOptionsPerformanceAnalysisStackedChart).length === 0) {
      return defaultSorting;
    }
    return pagesConfig.sortingOptionsPerformanceAnalysisStackedChart;
  };

  const stackedChartSorting: SortingOptionsType = getSortingOptions();

  const updateStackedChartSortingOptions = useCallback(
    (options: SortingOptionsType) => {
      pagesConfig.setSortingOptionsPerformanceAnalysisStackedChart(options);
    },
    [tableId, pagesConfig],
  );

  return { stackedChartSorting, updateStackedChartSortingOptions };
};

export default usePersistedSortingPerformanceAnalysisStackedChart;
